import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CourseCardComponent } from "../../../components/coursesComponents/course-card/course-card.component";
import { RouterModule } from '@angular/router';
import { CourseService } from '../course.service';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { PaginationComponent } from '../../../components/pagination/pagination.component';

@Component({
  selector: 'app-courses-list',
  standalone: true,
  imports: [FormsModule, CommonModule, CourseCardComponent,RouterModule, PaginationComponent],
  templateUrl: './courses-list.component.html',
  styleUrl: './courses-list.component.css'
})
export class CoursesListComponent {

  currentTab = 'all'
  tabs = [
    { name: 'All', value: 'all' },
    { name: 'Video Courses', value: 'video' },
    { name: 'Flashcard Courses', value: 'flashcard' },
    { name: 'Test Series', value: 'test' },
  ]

  coursesList: any = [];
  coursesListClone: any = [];
  fullCoursesList: any = [];
  paginationData: any = null;
  currentFilter: any[] = [];
  currentStatusLabel: string = 'All';

  constructor(private courseApiService: CourseService,private toasterService: ToasterService){}


  ngOnInit(): void {
    this.getCourses();
  }

  getCourses(page?: number | string, filters?: any[]) {
    const courseType = this.currentTab;

    this.courseApiService
      .getAllCourses(page, filters, courseType)
      .subscribe((res: any) => {
        try {
          if (res.body.status === 'success') {
            this.coursesList = res.body.data;
            this.coursesListClone = res.body.data;
            this.fullCoursesList = res.body.data; // kept for backward compatibility
            this.paginationData = this.transformPagination(res.body.pagination);
          }
        } catch (error) {
          this.toasterService.setToaster('error', 'Error', 'Something went wrong while fetching courses');
          console.error('Error fetching courses:', error);
        }
      });
  }


  changeTab(value: string) {
    this.currentTab = value;
    // Let backend filter by course_type (video/flashcard/etc).
    this.getCourses(1, this.currentFilter);
  }


  transformPagination(pag: any) {
    const pages = [];
    for (let i = 1; i <= pag.last_page; i++) {
      pages.push(i);
    }
    return {
      pages,
      current_page: pag.current_page,
      prev_page: pag.current_page > 1 ? pag.current_page - 1 : null,
      next_page: pag.current_page < pag.last_page ? pag.current_page + 1 : null,
    };
  }

  onPageChange(page: number) {
    this.getCourses(page, this.currentFilter);
  }

  selectStatus(status: string) {
    if (status === 'all') {
      this.currentFilter = [];
      this.currentStatusLabel = 'All';
    } else if (status === 'draft') {
      this.currentFilter = [{ filter_key: 'is_published', filter_value: '0' }];
      this.currentStatusLabel = 'Draft';
    } else if (status === 'publish') {
      this.currentFilter = [{ filter_key: 'is_published', filter_value: '1' }];
      this.currentStatusLabel = 'Published';
    }
    // Keep course_type filtering in sync as well.
    this.getCourses(1, this.currentFilter);
  }


}
